import { Status as StatusType } from '../statuses';
import { Type as CampaignType } from '../types';

export const allStatuses = [
    {
        label: 'All',
        status: '',
        value: ''
    },
    {
        label: 'Draft',
        status: StatusType.Draft,
        value: 'draft'
    },
    {
        label: 'Active',
        status: StatusType.Active,
        value: 'active'
    },
    {
        label: 'Stopped',
        status: StatusType.Stopped,
        value: 'stopped'
    },
    {
        label: 'Closed',
        status: StatusType.Closed,
        value: 'closed'
    },
    {
        label: 'Suspended',
        status: StatusType.Suspended,
        value: 'suspended'
    },
    {
        label: 'Waiting for approval',
        status: StatusType.WaitingForApproval,
        value: 'waiting_for_approval'
    },
    {
        label: 'Not Approved',
        status: StatusType.NotApproved,
        value: 'not_approved'
    },
    {
        label: 'Scheduled',
        status: StatusType.Scheduled,
        value: 'scheduled'
    }
];
export const allTypes = [
    {
        label: 'All',
        type: '',
        value: ''
    },
    {
        label: 'Medium Rectangle',
        type: CampaignType.SmallBanner,
        value: 'small_banner'
    },
    {
        label: 'Leaderboard',
        type: CampaignType.BigBanner,
        value: 'big_banner'
    },
    {
        label: 'Video',
        type: CampaignType.Video,
        value: 'video'
    },
    {
        label: 'Poll',
        type: CampaignType.Poll,
        value: 'poll'
    },
];
